"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionResult = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var hooks_1 = require("@use-ui/hooks");
/**
 * Display block with success result or error message.
 *
 * To use this component, you need to wrap your component tree in a
 * [ResultContext from @use-ui/hooks](https://github.com/vasyas/use-ui-hooks/blob/master/api-docs/README.md#resultcontext).
 */
function ActionResult(_a) {
    var _b = _a.error, error = _b === void 0 ? undefined : _b;
    var result = hooks_1.useResult().result;
    if (!error && !result)
        return null;
    return (React.createElement("div", { className: classnames_1.default("alert", { "alert-danger": !!error, "alert-success": !!result }) }, error || result));
}
exports.ActionResult = ActionResult;
